import { render, staticRenderFns } from "./Erp6SalePrepayment.vue?vue&type=template&id=a20367a6&scoped=true&"
import script from "./Erp6SalePrepayment.vue?vue&type=script&lang=js&"
export * from "./Erp6SalePrepayment.vue?vue&type=script&lang=js&"
import style0 from "./Erp6SalePrepayment.vue?vue&type=style&index=0&id=a20367a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20367a6",
  null
  
)

export default component.exports